module.exports = __webpack_public_path__ + "img/D.Toth-Kriszta-cikk.7fbf6f57.jpg";